import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

import { theme } from '_constants/theme';

import Text from '_components/atomic/layouts/Card/Text';
import Button from '_components/atomic/Button';

const GlobeConfirmedSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M31.248 20C31.248 26.2132 26.2113 31.25 19.998 31.25M31.248 20C31.248 13.7868 26.2113 8.75 19.998 8.75M31.248 20H8.74805M19.998 31.25C13.7848 31.25 8.74805 26.2132 8.74805 20M19.998 31.25C22.812 28.1694 24.4111 24.1715 24.498 20C24.4111 15.8285 22.812 11.8306 19.998 8.75M19.998 31.25C17.1841 28.1694 15.585 24.1715 15.498 20C15.585 15.8285 17.1841 11.8306 19.998 8.75M8.74805 20C8.74805 13.7868 13.7848 8.75 19.998 8.75"
      stroke={theme.colors.indigo[600]}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  width: 56px;
  padding: ${theme.spaces.smallX}px;
  background-color: ${theme.colors.white};
  border-radius: 12px;
  box-shadow: inset 0 0.5px 0 0 #fff, 0 0 0 0.5px rgba(0, 0, 0, 0.08),
    0 0 0 2px rgba(0, 0, 0, 0.02), 0 6px 6px -2px rgba(17, 25, 39, 0.06),
    0 2px 4px -2px rgba(17, 25, 39, 0.03);
`;

const StyledHeader = styled(Modal.Header)`
  padding-top: ${theme.spaces.regular}px;
  padding-bottom: ${theme.spaces.regular}px;
  padding-left: ${theme.spaces.large}px;
  padding-right: ${theme.spaces.large}px;
  gap: ${theme.spaces.regular}px;
`;

const StyledFooter = styled(Modal.Footer)`
  flex-wrap: nowrap;
  gap: ${theme.spaces.regular}px;
  padding-top: ${theme.spaces.regular}px;
  padding-bottom: ${theme.spaces.regular}px;
  padding-left: ${theme.spaces.large}px;
  padding-right: ${theme.spaces.large}px;
`;

const StyledBody = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: ${theme.spaces.regular}px;
  padding-bottom: ${theme.spaces.regular}px;
  padding-left: ${theme.spaces.large}px;
  padding-right: ${theme.spaces.large}px;
`;

const ConfirmationModal = ({
  children,
  visible,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      dialogClassName="confirmation-modal"
      show={visible}
      backdrop="static"
      keyboard={false}
      centered
    >
      <StyledHeader>
        <StyledIconContainer>
          <GlobeConfirmedSvg />
        </StyledIconContainer>
        <Text size={theme.fontSizes.large} weight={700}>
          Confirm
        </Text>
      </StyledHeader>
      <StyledBody>{children}</StyledBody>
      <StyledFooter>
        <Button secondary onClick={onCancel}>
          <Text
            inline
            size={theme.fontSizes.regular}
            weight={500}
            color={theme.colors.gray[500]}
          >
            {cancelLabel}
          </Text>
        </Button>
        <Button onClick={onConfirm}>
          <Text
            inline
            size={theme.fontSizes.regular}
            weight={500}
            color={theme.colors.white}
          >
            {confirmLabel}
          </Text>
        </Button>
      </StyledFooter>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  visible: PropTypes.bool,
  cancelLabel: PropTypes.node,
  confirmLabel: PropTypes.node,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ConfirmationModal;
